const alerts = {
    'error' :  { color: 'negative', message: 'Woah! Danger!', icon: 'report_problem', position:'bottom-right', timeout : 2000, detail: '',},
    'success' :  { color: 'positive', message: 'Woah! Danger!', icon: 'save', position:'bottom-right', timeout : 2000, },
}

const VuNotify = {}

VuNotify.install = (Vue) => {
    Vue.prototype.$admns = new Vue({
        name : '$admns',
        created () {
        },

        methods : {
            showNotify(nMessage, nType, detail='') {
                const n = alerts[nType];
                n.message = nMessage
                n.detail = detail;
                this.$q.notify(n);
            }
        }



    });
}

export default VuNotify;
  